module.exports = "<h1>\r\n  {{actionType}}\r\n</h1>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/steps/step-action-type/step-action-type.component.html
// module id = ./src/app/steps/step-action-type/step-action-type.component.html
// module chunks = main